module.exports = __webpack_public_path__ + "img/framboise_snit_2.12c98b55.jpg";